<button
  type="button"
  class="group flex items-center gap-1.5 w-full py-0.5 bg-transparent border-0 cursor-pointer text-left text-xs text-gray-800"
  [attr.aria-expanded]="_expanded()"
  (click)="toggle()">
  @if (live()) {
    <span
      class="material-symbols-outlined flex-shrink-0 text-sm text-blue-500 animate-spin"
      aria-hidden="true">
      progress_activity
    </span>
  } @else {
    <span
      class="material-symbols-outlined flex-shrink-0 text-sm text-gray-700 transition-transform"
      [class.rotate-90]="_expanded()">
      chevron_right
    </span>
  }
  <span
    class="flex-1 font-medium italic group-hover:text-gray-1100"
    [class.text-blue-700]="live()">
    {{ label() }}
  </span>
</button>
@if (_expanded()) {
  <div
    class="flex flex-col gap-2 pt-1.5 pb-2 pl-5 ml-[0.4375rem] border-l border-gray-300">
    @for (step of steps(); track step.id) {
      @switch (step.kind) {
        @case ("tools") {
          @for (tc of step.tools; track tc.id) {
            <portal-tool-call
              [name]="tc.name"
              [args]="tc.args"
              [result]="tc.result"
              [state]="tc.state" />
          }
        }
        @case ("reasoning") {
          <div
            class="prose prose-sm max-w-none text-gray-800"
            [innerHTML]="renderReasoning(step.content)"></div>
        }
      }
    }
  </div>
}
